import { useSelector } from 'react-redux';
import Global from '../store/global-selectors';

export const useCurrentUser = () => useSelector(Global.selectUserCurrentUserInfo);
